import { useStore, useUnit } from 'effector-react';
import $$api from 'models/api';
import { $queryParams } from 'models/location';
import navigate from 'models/router-gate';
import { $global } from 'models/store-global';
import { useEffect } from 'react';

import ModalsService from 'services/ModalsService';

import useEventListener from 'hooks/useEventListener';
import useResources from 'hooks/useResources';

const useAdvisorsGroupLinker = () => {
    const { t } = useResources();
    const params = useStore($queryParams);
    const code = params['group-invite'] || localStorage.getItem('group-invite');

    const isAuthorized = useUnit($global.map((state) => state.auth?.userRole || 'guest')) !== 'guest';
    const isAdvisorRelevantSigned = useUnit($global.map((state) => state.tac?.advisor?.isRelevantSigned === true));

    const handlers = {
        openInviteModality: async () => {
            if (code) {
                const group = await $$api.advisor.getGroupByCodeFx(code);
                ModalsService.showModality(
                    t('advisor.acceptGroupInviteModal.title'),
                    t('advisor.acceptGroupInviteModal.body', { ...group }),
                    {
                        closeButton: t('advisor.acceptGroupInviteModal.closeButton'),
                        confirmButton: t('advisor.acceptGroupInviteModal.confirmButton'),
                        onConfirm: async () => {
                            await $$api.advisor.linkAdvisorToGroupFx(code);
                            localStorage.removeItem('group-invite');
                            navigate('/advisor/dashboard');
                        },
                    },
                );
            }
        },
    };

    useEffect(() => {
        if (!code) {
            return;
        }

        if (isAuthorized) {
            if (isAdvisorRelevantSigned) {
                handlers.openInviteModality();
            }
        } else {
            localStorage.setItem('group-invite', code);
        }
    }, [code, isAuthorized, isAdvisorRelevantSigned]);

    useEventListener('beforeunload', () => {
        localStorage.removeItem('group-invite');
    });
};

export default useAdvisorsGroupLinker;
